import TrackingMappersFactory from '../../tracking/Mappers/factory.js'
import TrackingRepositoriesFactory from '../Repositories/factory.js'
import TrackingServicesFactory from '../Services/factory.js'
import TrackingValueObjectsFactory from '../ValueObjects/factory.js'
import GetAdvertisementsTrackingUseCase from './GetAdvertisementsTrackingUseCase.js'
import {GetEventTrackingDataUseCase} from './GetEventTrackingDataUseCase.js'
import {GetLeadDataTrackingUseCase} from './GetLeadDataTrackingUseCase.js'
import {GetPageTrackingDataUseCase} from './GetPageTrackingDataUseCase.js'
import {GetPublishAdTrackingUseCase} from './GetPublishAdTrackingUseCase.js'
import {SavePageViewHitTrackingUseCase} from './SavePageViewHitTrackingUseCase.js'
import UpdateBrazeUserUseCase from './UpdateBrazeUserUseCase.js'

export default class TrackingUseCasesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Object} deps.config
   * @return {GetPageTrackingDataUseCase}
   * @property {Function} repositoryFactory
   */
  static getPageTrackingDataUseCase = ({config}) =>
    new GetPageTrackingDataUseCase({
      config,
      trackingDataService: TrackingServicesFactory.getPageTrackingDataService({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Object} deps.config
   * @return {GetEventTrackingDataUseCase}
   * @property {Function} repositoryFactory
   */
  static getEventTrackingDataUseCase = ({config}) =>
    new GetEventTrackingDataUseCase({
      config,
      trackingDataService: TrackingServicesFactory.getEventTrackingDataService({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Object} deps.config
   * @return {GetAdvertisementsTrackingUseCase}
   */
  static getAdvertisementsTrackingUseCase = ({config}) =>
    new GetAdvertisementsTrackingUseCase({
      getAdvertisementsTrackingService: TrackingServicesFactory.getAdvertisementsTrackingService({config})
    })

  static getPublishAdTrackingUseCase = ({config}) =>
    new GetPublishAdTrackingUseCase({
      config,
      fromDraftJsonToDraftTrackingJsonMapper: TrackingMappersFactory.fromDraftJsonToDraftTrackingJsonMapper({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Object} deps.config
   * @return {UpdateBrazeUserUseCase}
   */
  static updateBrazeUserUseCase = ({config}) =>
    new UpdateBrazeUserUseCase({
      repository: TrackingRepositoriesFactory.brazeUserRepository({config})
    })

  static getLeadDataTrackingUseCase = ({config}) =>
    new GetLeadDataTrackingUseCase({
      config,
      getLeadDataTrackingService: TrackingServicesFactory.getLeadDataTrackingService({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Object} deps.config
   * @return {SavePageViewHitTrackingUseCase}
   */
  static savePageViewHitTrackingUseCase = ({config}) =>
    new SavePageViewHitTrackingUseCase({
      config,
      pageViewHitTrackingVOFactory: TrackingValueObjectsFactory.pageViewHitTrackingValueObject,
      savePageViewHitTrackingService: TrackingServicesFactory.savePageViewHitTrackingService({config})
    })
}
